import React from "react";
import { Phone } from "lucide-react";
import { useTwilioVoice } from "@/context/TwilioVoiceContext";

/**
 * Inline Call button — only renders for sales reps.
 * @param {string} phone - the phone number to dial
 * @param {object} extra - extra params forwarded to Twilio (ContactId, CompanyId)
 */
export default function CallButton({ phone, contactId, companyId, size = "sm", className = "" }) {
  const t = useTwilioVoice();
  if (!t.enabled || !phone) return null;

  const onClick = (e) => {
    e.stopPropagation();
    let num = String(phone).replace(/\s+/g, "");
    if (!num.startsWith("+")) num = num.startsWith("00") ? `+${num.slice(2)}` : `+30${num}`;
    t.startCall(num, contactId ? { ContactId: contactId } : {});
  };

  const sizes = {
    xs: "w-7 h-7",
    sm: "w-8 h-8",
    md: "w-10 h-10",
  };

  return (
    <button
      data-testid={`call-btn-${contactId || "x"}`}
      onClick={onClick}
      disabled={!t.deviceReady}
      title={t.deviceReady ? `Call ${phone}` : "Softphone connecting..."}
      className={`${sizes[size]} inline-flex items-center justify-center rounded-full bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40 shadow-sm transition-colors ${className}`}
    >
      <Phone className="w-4 h-4" />
    </button>
  );
}
